import styled from "styled-components";

const FONT = "'Source Code Pro', monospace";

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;
  font-family: ${FONT};

  @media print {
    font-size: 9pt;
  }
`;

export const SpanTitleInvoice = styled.strong`
  font-size: 26px;
  font-weight: 300;
`;

export const SpanTitleQrCode = styled.strong`
  font-size: 26px;
  font-weight: 300;
  text-align: center;
  justify-content: center;
  margin-top: 5px;
`;

export const SpanTextInvoiceBold = styled.strong`
  font-size: 26px;
  font-weight: 600;
  padding-left: 1rem;
`;

export const SmallTextInvoice = styled.small`
  font-size: 36px;
  padding-right: 1rem;
`;

export const BiggerTextInvoice = styled.strong`
  font-size: 4rem;
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 14px;
  font-family: ${FONT};

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitleDataBold = styled.span`
  color: #707070;
  font-weight: bold;
  font-size: 13px;
  margin-left: 1%;

  @media print {
    margin-left: 0;
    color: #000;
    font-size: 7pt;
  }
`;

export const TextParagraph = styled.div`
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 200px;

  @media print {
    font-size: 24pt;
  }
`;

export const SpanTextValueTitle = styled.span`
  color: #000;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;
  font-family: ${FONT};

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SpanTextValuePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
    color: #000;
  }
`;
export const SpanTextValueTitlePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
  }
`;
export const SpanTextValueBold = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: bold;

  @media print {
    font-size: 7pt;
  }
`;

export const TitleFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;

  @media print {
    font-size: 9pt;
  }
`;

export const DateFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;
  display: flex;
  justify-content: flex-end;

  @media print {
    font-size: 8pt;
  }
`;

export const TitleH1 = styled.span`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
`;

export const DescriptionH2 = styled.span`
  text-align: center;
  font-size: 13px;
  font-weight: 600;

  @media print {
    font-size: 9pt;
    color: #000;
  }
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 34%;
  height: 55%;
  /* max-width: 500px; */
  max-height: 400px;
  padding: 15px;
  margin: 0px;
  background-color: #f5f5f5;
  /* position: absolute; */

  @media print {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }
`;

export const Box = styled.div`
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #e7e7e7;
  border-width: 1px;
  border-color: 10px;
  margin-top: 10px;
  elevation: 10;
`;

export const QrCodePicture = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: #e7e7e7;
  border-width: 1px;
  border-color: 10px;
  elevation: 10;
`;

/* Thermal receipt styled components */

export const ReceiptWrapper = styled.div`
  font-family: ${FONT};
  color: #000;
  width: 100%;
  box-sizing: border-box;

  @media print {
    font-family: ${FONT};
    color: #000 !important;
  }
`;

export const ReceiptHeader = styled.div`
  text-align: left;
  padding-bottom: 2mm;
  font-family: ${FONT};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2mm;

  @media print {
    padding-bottom: 2.5mm;
    justify-content: space-between;
    display: flex;
  }
`;

export const ReceiptTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  letter-spacing: 1px;
  font-family: ${FONT};
  flex: 1 1 auto;
  line-height: 1.15;

  @media print {
    font-size: 12pt;
  }
`;

export const ReceiptDate = styled.span`
  font-size: 15px;
  font-weight: normal;
  display: block;
  margin-top: 2px;
  font-family: ${FONT};
  flex: 0 0 auto;
  white-space: nowrap;
  text-align: right;

  @media print {
    font-size: 10pt;
  }
`;

export const ReceiptBrand = styled.span`
  font-size: 16px;
  font-weight: bold;
  display: block;
  margin-top: 2px;
  font-family: ${FONT};

  @media print {
    font-size: 11pt;
  }
`;

export const ReceiptDivider = styled.hr`
  border: none;
  border-top: 1px dashed #555;
  margin: 3mm 0;
  width: 100%;

  @media print {
    border-top: 1px dashed #000;
    margin: 3mm 0;
  }
`;

export const ReceiptRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-family: ${FONT};
  font-size: 14px;
  line-height: 1.5;

  @media print {
    font-size: 10pt;
  }
`;

export const ReceiptLabel = styled.span`
  font-family: ${FONT};
  white-space: nowrap;

  @media print {
    font-size: 14px;
  }
`;

export const ReceiptValue = styled.span`
  font-weight: normal;
  font-family: ${FONT};
  text-align: right;

  @media print {
    font-size: inherit;
  }
`;

export const ReceiptSectionTitle = styled.span`
  font-weight: bold;
  font-size: 15px;
  display: block;
  margin-bottom: 1mm;
  font-family: ${FONT};

  @media print {
    font-size: 11pt;
  }
`;

export const ReceiptDateGroup = styled.span`
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: baseline;
  gap: 3mm;
  margin-top: 1.5mm;
  margin-bottom: 0.5mm;
  font-family: ${FONT};

  @media print {
    font-size: 10pt;
    gap: 2mm;
  }
`;

export const ReceiptTransactionHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 3mm;
  font-weight: bold;
  font-size: 14px;
  margin-top: 1.5mm;
  margin-bottom: 0.5mm;
  font-family: ${FONT};

  @media print {
    font-size: 10pt;
    gap: 2mm;
  }
`;

export const ReceiptTransactionStore = styled.span`
  font-weight: bold;
  font-family: ${FONT};

  @media print {
    font-size: inherit;
  }
`;

export const ReceiptTransaction = styled.div`
  font-size: 14px;
  padding-left: 2mm;
  display: flex;
  justify-content: space-between;
  line-height: 1.5;
  font-family: ${FONT};

  @media print {
    font-size: 9pt;
    padding-left: 0;
  }
`;

export const ReceiptTransactionDesc = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  font-family: ${FONT};

  @media print {
    font-size: 11px;
    white-space: normal;
  }
`;

export const ReceiptTransactionValue = styled.span`
  font-weight: normal;
  margin-left: 4px;
  white-space: nowrap;
  font-family: ${FONT};

  @media print {
    font-size: inherit;
  }
`;

export const ReceiptClientRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
  font-family: ${FONT};
  line-height: 1.5;
  padding-bottom: 2mm;

  @media print {
    font-size: 10pt;
    padding-bottom: 2mm;
  }
`;

export const ReceiptClientCol = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${FONT};
`;

export const ReceiptStatusRow = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  font-family: ${FONT};

  @media print {
    font-size: 10pt;
  }
`;

export const ReceiptFooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: ${FONT};
  line-height: 1.5;

  @media print {
    font-size: 10pt;
  }
`;
